export function mapCmsShowcaseDataToShowcaseSettings(
  showcaseRawData: StrapiResponseData<ShowcaseContentType> | undefined
): ShowcaseSettings {
  const cmsData = showcaseRawData?.attributes;

  return {
    sharingFaqItemIds: (cmsData?.help?.sharing_faq_items ?? [])
      .map(item => item.article_id ?? '')
      .filter(articleId => articleId !== ''),
    leasingFaqItemIds: (cmsData?.help?.leasing_faq_items ?? [])
      .map(item => item.article_id ?? '')
      .filter(articleId => articleId !== ''),
    announcementBanner: {
      title: cmsData?.announcement_banner?.title ?? '',
      description: cmsData?.announcement_banner?.description ?? '',
      buttonText: cmsData?.announcement_banner?.cta_text ?? '',
      buttonLocation: cmsData?.announcement_banner?.cta_link ?? '',
      type: cmsData?.announcement_banner?.type ?? 'info',
      closable: cmsData?.announcement_banner?.closable ?? true,
      startDate: cmsData?.announcement_banner?.start_date ?? '',
      endDate: cmsData?.announcement_banner?.end_date ?? '',
    },
  };
}
